import {
  makeStyles,
  Theme,
  createStyles,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  DialogProps,
  Box,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Button } from "~components/Button";

type ActionProps =
  | {
      children: React.ReactChildren;
      handleNo?: never;
      handleYes?: never;
      noLabel?: never;
      yesLabel?: never;
    }
  | {
      handleNo: () => void;
      handleYes: () => void;
      yesLabel: string;
      noLabel: string;
    };

export type ModalProps = {
  open: boolean;
  title: string;
  content: string;
  onClose: () => void;
} & ActionProps &
  DialogProps;

export const Modal = ({ open, children, onClose, ...props }: ModalProps) => {
  const classes = useStyles();
  const { title, content } = props;

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      classes={{ paper: classes.paper }}
      onClose={onClose}
      {...props}
    >
      <DialogTitle disableTypography id="confirmation-dialog-title" className={classes.dialogTitle}>
        <div style={{ width: 42, visibility: "hidden" }} aria-hidden />
        <Typography className={classes.dialogTitleText}>{title}</Typography>
        <IconButton aria-label="close" className={classes.close} color="primary" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>{content}</DialogContent>
      <DialogActions className={classes.dialogActions} disableSpacing>
        {children || (
          <>
            <Button onClick={props.handleNo} buttonType="secondary">
              {props.noLabel}
            </Button>
            <Box marginRight={4} />
            <Button onClick={props.handleYes} buttonType="primary">
              {props.yesLabel}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: 520,
      minWidth: 520,
      borderRadius: 4,
      boxShadow: "0 10px 12px 0 rgba(32, 37, 43, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)",
      backgroundColor: "white",
      textAlign: "center",
      paddingBottom: theme.spacing(4),
    },
    dialogTitle: {
      padding: `
        ${theme.spacing(2.5)}px
        ${theme.spacing(2)}px
        ${theme.spacing(2.25)}px
        ${theme.spacing(2)}px`,
      borderRadius: 4,
      backgroundColor: "#fbfbfb",
      boxShadow: `0 0 1px 0 ${theme.palette.blueGrey.main}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    dialogTitleText: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "normal",
      color: theme.palette.dark.main,
    },
    dialogContent: {
      padding: `${theme.spacing(3)}px ${theme.spacing(4)}px ${theme.spacing(4)}px`,
      fontSize: 14,
      fontWeight: "normal",
      lineHeight: 1.36,
      textAlign: "center",
      color: theme.palette.battleshipGrey.main,
    },
    dialogActions: {
      padding: 0,
      margin: 0,
      justifyContent: "center",
    },
    close: {
      width: 42,
      height: 42,
    },
  }),
);
